import ApiHelper from './index';

const fetchTasks = async (spinner = true) => {
  return await ApiHelper.get('organization/task/', spinner);
};

const fetchOrganizationTasks = async (queryParam, spinner = true) => {
  return await ApiHelper.get('organization/task/taskpage', spinner, queryParam);
};

const fetchAllTaskAdminPanel = async (query, spinner) => {
  return await ApiHelper.get('organization/tasks/admin', spinner, query);
};

const cloneTasks = async (payload, spinner = true) => {
  return await ApiHelper.post('generic/clone_task/', payload, spinner);
};

const cloneTaskV2 = async (payload, spinner = true) => {
  return await ApiHelper.post('generic/clone_task_v2/', payload, spinner);
};

const fetchTrainedTasksByStatus = async (status, spinner = true) => {
  return await ApiHelper.get(
    `organization/task/get_all_trained_tasks_of_organization?train_status=${status}`,
    spinner
  );
};

const fetchTaskDetailsNew = async (
  taskId,
  spinner = true,
  historyId = null
) => {
  const url = historyId
    ? `organization/task_history/${taskId}/?history_id=${historyId}`
    : `organization/task_history/${taskId}/`;

  return await ApiHelper.get(url, spinner);
};

const fetchTaskDetails = async (taskId, spinner = true) => {
  return await ApiHelper.get(`organization/task/${taskId}/`, spinner);
};
const addTask = async (payload, spinner = true) => {
  return await ApiHelper.post('organization/task/', payload, spinner);
};

const fetchTaskStatus = async (taskId, spinner = true) => {
  return await ApiHelper.get(`organization/trained_task/${taskId}`, spinner);
};

const updateTask = async (taskId, payload, spinner = true) => {
  return await ApiHelper.patch(
    `organization/task/${taskId}/`,
    payload,
    spinner
  );
};

const deleteTask = async (taskId, spinner = true) => {
  return await ApiHelper.patch(
    `organization/task/${taskId}/`,
    { is_deleted: true },
    spinner
  );
};

const fetchTaskObjects = async (taskId, spinner) => {
  return await ApiHelper.get(
    `organization/task/list_task_objects/${taskId}/`,
    spinner
  );
};

const fetchTaskPlaneObjects = async (taskId, spinner = false) => {
  return await ApiHelper.get(
    `organization/task/list_plane_objects/${taskId}/`,
    spinner
  );
};

const addTaskObject = async (payload, spinner) => {
  return await ApiHelper.post(
    `organization/task/task_object/`,
    payload,
    spinner
  );
};

const addPlaneObject = async (payload, spinner) => {
  return await ApiHelper.put(
    `organization/task/plane_objects/${payload.id}/`,
    payload,
    spinner
  );
};

const deletePlaneObject = async (id, spinner) => {
  return await ApiHelper.remove(
    `organization/task/plane_objects/${id}/`,
    spinner
  );
};

const createNewPlane = async (payload, spinner) => {
  return await ApiHelper.post(
    `organization/task/plane_objects/`,
    payload,
    spinner
  );
};

const updateTaskObject = async (objectId, payload, spinner = true) => {
  return ApiHelper.patch(
    `organization/task/task_object/${objectId}/`,
    payload,
    spinner
  );
};

const deleteTaskObject = async (objectId, spinner = true) => {
  return ApiHelper.remove(
    `organization/task/task_object/${objectId}/`,
    spinner
  );
};

const fetchTaskObjectRules = async (taskId, spinner) => {
  return await ApiHelper.get(
    `/organization/task/object_detection_rule/${taskId}/`,
    spinner
  );
};

const createTaskObjectRules = async (taskId, payload, spinner) => {
  return await ApiHelper.post(
    `/organization/task/object_detection_rule/${taskId}/`,
    payload,
    spinner
  );
};

const deleteTaskObjectRules = async (params, spinner) => {
  return await ApiHelper.remove(
    `/organization/task/object_detection_rule/delete/`,
    spinner,
    params
  );
};

const deleteMultipleObjects = async (payload, spinner = false) => {
  return await ApiHelper.patch(
    'organization/task/object_detection_rule/bulk_delete',
    payload,
    spinner
  );
};

const updateTaskObjectDetectionRule = async (ruleId, payload, spinner) => {
  return await ApiHelper.patch(
    `/organization/task/object_detection_rule/${ruleId}/`,
    payload,
    spinner
  );
};

const updateTrainedTask = async (id, payload, spinner = true) => {
  return await ApiHelper.patch(
    `organization/trained_task/${id}`,
    payload,
    spinner
  );
};

const stopTrainingOfTask = async (payload, spinner = true) => {
  return await ApiHelper.put('organization/train/stop/', payload, spinner);
};

const updateCloneTask = async (payload, spinner = true) => {
  return await ApiHelper.patch('/generic/clone_task/', payload, spinner);
};

const getTaskStaticObjectList = async (id, spinner = false) => {
  return await ApiHelper.get(
    `organization/task/list_task_objects/${id}/?is_static=${true}`,
    spinner
  );
};

const getProjectorRegions = async (id, spinner = false) => {
  return await ApiHelper.get(`generic/list_region_json/${id}/`, spinner);
};

const getTaskStepMediaObjects = async (taskId, spinner = false) => {
  return await ApiHelper.get(
    `organization/task/s3_objects/${taskId}/`,
    spinner
  );
};

const patchTaskLastUpdate = async (taskId) => {
  return await ApiHelper.patch(`organization/task/last_update/${taskId}`);
};

const createRectificationSteps = async (data) => {
  return await ApiHelper.post(`organization/rectification_steps/`, data);
};

const fetchedRectificationSteps = async (taskId) => {
  return await ApiHelper.get(
    `organization/rectification_steps/?task=${taskId}`
  );
};

const fetchValidatedVideoByGroup = async (groupId) => {
  return await ApiHelper.get(
    `websocket_inference/validation_record/group/${groupId}/`
  );
};

const deleteRectificationStep = async (taskId) => {
  return await ApiHelper.remove(`organization/rectification_steps/${taskId}`);
};

const getAnnotationCheckStatus = async (taskId) => {
  return await ApiHelper.get(`organization/task/annotations_check/${taskId}`);
};

const fetchTaskChangelog = async (
  taskId,
  { before = null, limit = 20 } = {},
  spinner = false
) => {
  const params = before ? { before, limit } : { limit };
  return await ApiHelper.get(
    `organization/task/${taskId}/changelog/`,
    spinner,
    params
  );
};

const revertTaskToHistory = async (
  taskId,
  historyId,
  { dryRun = false } = {},
  spinner = true
) => {
  return await ApiHelper.patch(
    `organization/task/${taskId}/revert/`,
    { history_id: historyId, dry_run: dryRun },
    spinner
  );
};

const extractTaskFromDoc = async (data) => {
  return await ApiHelper.post('organization/task/extract_task_from_doc/', data);
};

const getDeviceTaskAssosiation = async (taskId, deviceId) => {
  return await ApiHelper.get(
    `device/get_device_tasks_association/?task=${taskId}&device=${deviceId}`
  );
};

const createValidationRecrodsFromTrace = async (data) => {
  return await ApiHelper.post(
    `websocket_inference/validation_records_from_trace/`,
    data
  );
};

export default {
  fetchTasks,
  fetchValidatedVideoByGroup,
  fetchTrainedTasksByStatus,
  fetchTaskDetails,
  fetchTaskDetailsNew,
  fetchTaskStatus,
  fetchTaskPlaneObjects,
  fetchTaskObjects,
  addTaskObject,
  updateTaskObject,
  deleteTaskObject,
  fetchTaskObjectRules,
  createTaskObjectRules,
  deleteTaskObjectRules,
  updateTaskObjectDetectionRule,
  addTask,
  updateTask,
  deleteTask,
  updateTrainedTask,
  fetchOrganizationTasks,
  fetchAllTaskAdminPanel,
  cloneTasks,
  cloneTaskV2,
  updateCloneTask,
  addPlaneObject,
  createNewPlane,
  getTaskStaticObjectList,
  deletePlaneObject,
  stopTrainingOfTask,
  getProjectorRegions,
  deleteMultipleObjects,
  getTaskStepMediaObjects,
  patchTaskLastUpdate,
  createRectificationSteps,
  fetchedRectificationSteps,
  deleteRectificationStep,
  getAnnotationCheckStatus,
  fetchTaskChangelog,
  revertTaskToHistory,
  extractTaskFromDoc,
  getDeviceTaskAssosiation,
  createValidationRecrodsFromTrace,
};
